import { render, staticRenderFns } from "./DeletedPosts.vue?vue&type=template&id=205287d6&"
import script from "./DeletedPosts.vue?vue&type=script&lang=js&"
export * from "./DeletedPosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports